import { from, Observable } from 'rxjs';

const headerName = `cache-storage-expiration`;

export async function fetchWithCache(req: Request, cacheName: string, ttl: number): Promise<any> {
  /**
   * Returns a cached response, making a request to the server if required.
   *
   * @param req - The request to make
   * @param cacheName - the cache that should be used for response
   * @param ttl - the number of milliseconds responses should be cached for
   * @returns the body of the response as a json object
   */
  const cache = await caches.open(cacheName);
  let resp = await cache.match(req.url);
  if (!resp || Date.parse(resp.headers.get(headerName)) < Date.now()) {
    resp = await fetch(req);
    //Response is duplicated to make mutable
    resp = new Response(resp.body, {
      headers: { [headerName]: new Date(Date.now() + ttl).toISOString() },
    });
    await cache.put(req, resp);
    //Response is obtained from cache to prevent 'Body has already been consumed' errors
    resp = await cache.match(req.url);
  }
  return await resp.json();
}

export function fetchWithCache$(req: Request, cacheName: string, ttl: number): Observable<any> {
  /**
   * Returns a cached response, making a request to the server if required.
   *
   * @param req - The request to make
   * @param cacheName - the cache that should be used for response
   * @param ttl - the number of milliseconds responses should be held for
   * @returns an observable of the body of the response as a json object
   *
   * @see fetchWithCache
   */
  return from(fetchWithCache(req, cacheName, ttl));
}
